import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EnumService from 'services/enum2';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const styles = {
  root: {
    width: 100,
  },
  input: {
    color: '#000',
  },
  icon: {
    color: '#000',
  },
};

class AreaCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
    };
    this.list = [];
  }

  init() {
    EnumService.getList('B01_Mobile_Area').then(data => {
      this.list = data;
      if (data.length > 0) {
        let code = this.list[0].subKey;
        if (this.state.code === '') {
          this.setState({ code: code });
        }
        this.emitChange(code);
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  emitChange = code => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(code);
    }
  };

  handleSelectChange = e => {
    let code = e.target.value;
    this.setState({ code: code });
    this.emitChange(code);
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="m-area-code">
        <Select
          value={this.state.code}
          onChange={e => this.handleSelectChange(e)}
          classes={{ select: classes.input, icon: classes.icon }}
          className="select-company-list"
        >
          {this.list.map((item, index) => (
            <MenuItem key={index} value={item.subKey}>
              {item.subValue}
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  }
}

AreaCode.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AreaCode);
